let http = {};
import axios from "axios";
import utils from "./utils";

// 自定义异常处理方式
function custErrStatusFun(vm, errStatus, errMsg) {
  utils.hideLoading(vm);
  switch (errStatus) {
    case 404:
      // utils.error(errMsg || '404')
      utils.showMsg(errMsg || "404");
      break;
    case 403:
      // utils.error(errMsg || '没有权限');
      utils.showMsg(errMsg || "没有权限");
      // vm.$router.push({
      //     name: 'login'
      // })
      break;
    default:
      utils.showMsg(errMsg || "请求失败");
    // utils.error(errMsg || '请求失败')
  }
}

// 自定义异常处理方式
function custErrFun(vm, err) {
  if (err.status == 500 || (err.response && err.response.status == 500)) {
    utils.hideLoading(vm);
    utils.showMsg("请求失败");
    // utils.error('请求失败');
  } else if (err.response && err.response.status !== 200) {
    if (err.response.status == 403) {
      // vm.$router.push({
      //     name: 'login'
      // })
      utils.hideLoading(vm);
    } else {
      utils.hideLoading(vm);
      utils.showMsg(err.response.data.msg || "请求失败");
      // utils.error(err.response.data.msg || '请求失败');
    }
  } else if (err.message && err.stack) {
    console.log(err);
  } else {
    // TODO 超时处理机制
    // 请求返回的异常
    var errStatus = err.response.status;
    custErrStatusFun(vm, errStatus);
  }
}

// 自定义返回处理
function custResponseFun(vm, res, resolve) {
  // if (vm.$store.state.reconfig) {
  //   // 重构的
  //   // 返回的状态
  //   const responseStatus = res.data.code;
  //   const responseMsg = res.data.msg || res.data.messageList;
  //   switch (responseStatus) {
  //     case "0000":
  //       resolve(res.data);
  //       break;
  //     default:
  //       custErrStatusFun(vm, responseStatus, responseMsg);
  //   }
  // } else {
  //   // 原来的
  //   // 返回的状态
  //   const responseStatus = res.data.status;
  //   const responseMsg = res.data.msg || res.data.messageList;
  //   switch (responseStatus) {
  //     case 200:
  //       resolve(res);
  //       break;
  //     default:
  //       custErrStatusFun(vm, responseStatus, responseMsg);
  //   }
  // }
  if (Object.keys(res.data).includes("status")) {
    // 老的
    console.log("老的请求");
    if (res.data.status == 200) {
      resolve(res);
    } else {
      const responseMsg = res.data.msg || res.data.messageList;
      custErrStatusFun(vm, res.data.status, responseMsg);
    }
  }
  if (Object.keys(res.data).includes("code")) {
    // 重构的
    console.log("重构的接口");
    if (res.data.code == "0000") {
      resolve(res.data);
    } else {
      const responseMsg = res.data.msg || res.data.messageList;
      custErrStatusFun(vm, res.data.code, responseMsg);
    }
  }
}

// get 请求
http.get = function (vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params || {},
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: vm.$store.state.token,
        },
        timeout: 60000,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

// POST 请求
http.post = function (vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          authorization: vm.$store.state.token,
          // 'authorization': 'ZD eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ7XCJhY2NvdW50Tm9uRXhwaXJlZFwiOnRydWUsXCJhY2NvdW50Tm9uTG9ja2VkXCI6dHJ1ZSxcImNvcnBOb1wiOlwiQ08xNTI0MTAwNzczODE1XCIsXCJjcmVkZW50aWFsc05vbkV4cGlyZWRcIjp0cnVlLFwiZGF0YUNoZWNrXCI6XCJOXCIsXCJkZWFsTm9cIjpcIlwiLFwiZW5hYmxlZFwiOnRydWUsXCJwYXNzd29yZFwiOlwiZTk5YTE4YzQyOGNiMzhkNWYyNjA4NTM2Nzg5MjJlMDNcIixcInJvbGVJZFwiOlwiXCIsXCJzaG93VXNlck5hbWVcIjpcImFkbWluXCIsXCJzdGF0dXNcIjpcIlwiLFwic3RhdHVzTmFtZVwiOlwiXCIsXCJ1c2VySWRcIjpcIlpvTlZETDREV1JHRk5JRFBSSUxLTVBVR1VZXCIsXCJ1c2VyTm9cIjpcIlwiLFwidXNlclBhc3N3b3JkXCI6XCJlOTlhMThjNDI4Y2IzOGQ1ZjI2MDg1MzY3ODkyMmUwM1wiLFwidXNlclBob25lXCI6XCJhZG1pblwiLFwidXNlcm5hbWVcIjpcImFkbWluXCJ9IiwiZXhwIjoxNjY3NzY2MzM5fQ.Mh0TfluUGpvl6E6qAYW-IRbyQyl1f4gPrC3xShsC1aHgVp_AKJnQCN7F0-G7EkWbHayRg1sx1d7jD8-xjWGb7g'
        },
        timeout: 60000,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        console.log(err);
        custErrFun(vm, err);
      });
  });
};

http.postFormData = function (vm, url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        headers: {
          "Content-Type": "multipart/form-data;charset=UTF-8",
          authorization: vm.$store.state.token,
        },
        timeout: 60000,
      })
      .then((res) => {
        custResponseFun(vm, res, resolve);
      })
      .catch((err) => {
        custErrFun(vm, err);
      });
  });
};

export default http;
